const DISTRICTTABLES = {
    "country": {
        shortName: "country",
        fullName: "user_siptea_country",
    },
    "province": {
        shortName: "province", //查询名
        fullName: "user_siptea_province", //库表名
        evacuationParams: ['0.01'] //抽稀参数
    },
    "city": {
        shortName: "city",
        fullName: "user_siptea_city",
        evacuationParams: ['0.03']
    },
    "county": {
        shortName: "county",
        fullName: "user_siptea_county",
        evacuationParams: ['0.12']
    }
}

const DIRECTCITYS = {
    '110000': {},
    '120000': {},
    '310000': {},
    '500000': {}
}

module.exports = {
    DISTRICTTABLES,
    DIRECTCITYS
};